import { useGetRestaurantQuery } from 'generated/rbi-graphql';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLogger } from 'state/logger';
import { useGetRestaurantAvailabilityFn } from 'utils/restaurant';

export const useRestaurantPosConnectivityStatus = (
  storeId: string | null,
  pollInterval?: number
) => {
  const logger = useLogger();
  const enableOrdering = useFlag(LaunchDarklyFlag.ENABLE_ORDERING);
  const checkAvailability = useGetRestaurantAvailabilityFn();

  const { data, loading, refetch } = useGetRestaurantQuery({
    fetchPolicy: 'cache-and-network',
    variables: { storeId },
    skip: !storeId || !enableOrdering,
    // skip does not apply to polling calls
    // if storeId is cleared, then we set the interval to 0 which ends the polling
    pollInterval: storeId ? pollInterval : 0,
    onError: err =>
      logger.warn({ err, message: `Failed to retrieve restaurant availability - ${storeId}` })
  });

  const rbiRestaurant = data?.restaurant;

  const isRestaurantPosOnline = checkAvailability(rbiRestaurant);

  return {
    isRestaurantPosOnline,
    loading,
    refetch
  };
};
